import { useState } from "react";
import { Form } from "antd";

import { type ScheduledFitnessAppAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";

import { type FitnessAppTaskFormModel } from "./types";

export const useFitnessAppTaskForm = () => {
  const [visible, toggleVisibility] = useState(false);
  const [formController] = Form.useForm<FitnessAppTaskFormModel>();
  const [editedTask, setTask] = useState<null | FitnessAppTaskFormModel>(null);

  const closeModal = () => {
    toggleVisibility(false);
    setTask(null);
  };

  const openModal = (task?: ScheduledFitnessAppAutomation) => {
    if (task) {
      setTask(task as unknown as FitnessAppTaskFormModel);
    }
    toggleVisibility(true);
  };

  return {
    visible,
    closeModal,
    openModal,
    editedTask,
    formController,
  };
};
